import React from "react";
import CameraIcon from "./CameraIcon";
import Colors from "../../constants/Colors";
import "../Link.css";

interface CameraContainerProps {
  onClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size: number;
}

const CameraContainer = (props: CameraContainerProps) => {
  const { onClick, size } = props;
  const computedStyle = {
    width: size,
    height: size,
    ...styles.cameraContainer,
  } as React.CSSProperties;
  if (typeof document === `undefined`) return null;
  const fileInput: HTMLElement | null = document.getElementById("file-input");
  if (fileInput?.[0]?.value) {
    fileInput[0].value = "";
  }
  const callback = () => {
    fileInput?.click();
  };
  return (
    <div style={styles.block}>
      <div onClick={callback} className="link" style={computedStyle}>
        <CameraIcon />
        <input
          id="file-input"
          hidden
          value=""
          type="file"
          name="file"
          accept="image/jpeg, image/jpg, image/png"
          onChange={onClick}
        />
      </div>
    </div>
  );
};

const styles = {
  block: {
    display: "inline-block",
    verticalAlign: "top",
  },
  cameraContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.grayLight,
  },
};

export default CameraContainer;
